import { z } from "zod";
import { IanaTimezoneSchema } from "./timezone.schema";

const IsoDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, "Date must be in YYYY-MM-DD format");

export const UsageViewBySchema = z.enum(["day", "week", "month"]);

export const UsageStatsQuerySchema = z.strictObject({
  viewBy: UsageViewBySchema.default("month"),
  anchorDate: IsoDateSchema,
  consumer: z.string().optional().default("all"),
  apiKeyId: z.string().optional().default("all"),
  model: z.string().optional().default("all"),
  timezone: IanaTimezoneSchema,
});

export const UsageFilterOptionSchema = z.object({
  value: z.string(),
  label: z.string(),
});

export const UsageChartSegmentSchema = z.object({
  modelKey: z.string(),
  label: z.string(),
  tokens: z.number(),
  inputTokens: z.number().optional().default(0),
  outputTokens: z.number().optional().default(0),
  cost: z.number(),
  inputCost: z.number().optional().default(0),
  outputCost: z.number().optional().default(0),
  color: z.string(),
});

export const UsageChartBucketSchema = z.object({
  key: z.string(),
  label: z.string(),
  totalTokens: z.number(),
  totalCost: z.number(),
  segments: z.array(UsageChartSegmentSchema),
});

export const UsageModelSeriesSchema = z.object({
  key: z.string(),
  label: z.string(),
  color: z.string(),
  tokens: z.number(),
  cost: z.number(),
});

export const UsageSummarySchema = z.object({
  inputTokens: z.number(),
  outputTokens: z.number(),
  totalTokens: z.number(),
  inputCost: z.number(),
  outputCost: z.number(),
  totalCost: z.number(),
  totalRequests: z.number(),
});

export const UsageStatsSchema = z.object({
  summary: UsageSummarySchema,
  buckets: z.array(UsageChartBucketSchema),
  models: z.array(UsageModelSeriesSchema),
  consumers: z.array(UsageFilterOptionSchema),
  apiKeys: z.array(UsageFilterOptionSchema),
  modelOptions: z.array(UsageFilterOptionSchema),
  periodLabel: z.string(),
});

export type UsageViewBy = z.infer<typeof UsageViewBySchema>;
export type UsageStatsQuery = z.infer<typeof UsageStatsQuerySchema>;
export type UsageFilterOption = z.infer<typeof UsageFilterOptionSchema>;
export type UsageChartSegment = z.infer<typeof UsageChartSegmentSchema>;
export type UsageChartBucket = z.infer<typeof UsageChartBucketSchema>;
export type UsageModelSeries = z.infer<typeof UsageModelSeriesSchema>;
export type UsageSummary = z.infer<typeof UsageSummarySchema>;
export type UsageStats = z.infer<typeof UsageStatsSchema>;
